<div class="flex flex-col gap-1">
  <!-- Parent Reference (features only) -->
  @if (isFeature()) {
    <dojo-single-select
      label="Parent Function"
      [formCtrl]="parentCtrl"
      [options]="parentOptions()"
      optionLabel="label"
      optionValue="value"
      [size]="'s'"
      (selectionChange)="onParentChange($event)"
    />

    @if (isDualParent()) {
      <dojo-single-select
        label="Second Function"
        [formCtrl]="parent2Ctrl"
        [options]="parentOptions()"
        optionLabel="label"
        optionValue="value"
        [size]="'s'"
        (selectionChange)="onParent2Change($event)"
      />
    }
  }

  @if (
    isPrimitive() ||
    numberParamEntries().length > 0 ||
    expressionParamEntries().length > 0 ||
    booleanParamKeys().length > 0 ||
    selectParamKeys().length > 0
  ) {
    @if (isPrimitive()) {
      <!-- Primitive: Label -->
      @if (primitiveType() === 'label') {
        <dojo-text-input label="Text" [formCtrl]="primLabelTextCtrl" [size]="'s'" placeholder="{f.a} or My label" />
        <dojo-number-input
          label="Precision"
          [formCtrl]="primLabelPrecisionCtrl"
          [min]="0"
          [max]="10"
          [step]="1"
          [size]="'s'"
        />
        <dojo-single-select
          label="Attach to"
          [formCtrl]="primLabelOfCtrl"
          [options]="allElementIdOptions()"
          optionLabel="label"
          optionValue="value"
          [size]="'s'"
          placeholder="None (standalone)"
          (selectionChange)="onPrimLabelOfChange($event)"
        />
        <div class="grid grid-cols-2 gap-1.5">
          <div class="flex min-w-0 items-end gap-0.5">
            @if (primExpressionModes().has('posX')) {
              <dojo-text-input
                class="min-w-0 flex-1"
                label="Pos X"
                [formCtrl]="getPrimExprCtrl('posX')"
                [size]="'s'"
                placeholder="expression"
              />
              <button
                class="mb-0.5 shrink-0 cursor-pointer rounded px-1 py-0.5 text-[9px] font-bold text-sky-500 hover:bg-red-50 hover:text-red-500"
                title="Switch to number"
                (click)="onPrimSwitchToNumber('posX')"
              >
                fx
              </button>
            } @else {
              <dojo-number-input
                class="min-w-0 flex-1"
                label="Pos X"
                [formCtrl]="primLabelPosXCtrl"
                [step]="0.5"
                [size]="'s'"
              />
              <button
                class="mb-0.5 shrink-0 cursor-pointer rounded px-1 py-0.5 text-[9px] font-bold text-neutral-300 hover:bg-sky-50 hover:text-sky-500"
                title="Switch to expression"
                (click)="onPrimSwitchToExpression('posX')"
              >
                fx
              </button>
            }
          </div>
          <div class="flex min-w-0 items-end gap-0.5">
            @if (primExpressionModes().has('posY')) {
              <dojo-text-input
                class="min-w-0 flex-1"
                label="Pos Y"
                [formCtrl]="getPrimExprCtrl('posY')"
                [size]="'s'"
                placeholder="expression"
              />
              <button
                class="mb-0.5 shrink-0 cursor-pointer rounded px-1 py-0.5 text-[9px] font-bold text-sky-500 hover:bg-red-50 hover:text-red-500"
                title="Switch to number"
                (click)="onPrimSwitchToNumber('posY')"
              >
                fx
              </button>
            } @else {
              <dojo-number-input
                class="min-w-0 flex-1"
                label="Pos Y"
                [formCtrl]="primLabelPosYCtrl"
                [step]="0.5"
                [size]="'s'"
              />
              <button
                class="mb-0.5 shrink-0 cursor-pointer rounded px-1 py-0.5 text-[9px] font-bold text-neutral-300 hover:bg-sky-50 hover:text-sky-500"
                title="Switch to expression"
                (click)="onPrimSwitchToExpression('posY')"
              >
                fx
              </button>
            }
          </div>
        </div>
        <div class="grid grid-cols-2 gap-1.5">
          <dojo-single-select
            label="Variant"
            [formCtrl]="primLabelVariantCtrl"
            [options]="labelVariantOptions"
            optionLabel="label"
            optionValue="value"
            [size]="'s'"
            placeholder="Default"
            (selectionChange)="onPrimLabelDisplayChange('variant', $event)"
          />
          <dojo-single-select
            label="Color"
            [formCtrl]="primLabelColorCtrl"
            [options]="labelColorOptions"
            optionLabel="label"
            optionValue="value"
            [size]="'s'"
            placeholder="Default"
            (selectionChange)="onPrimLabelDisplayChange('color', $event)"
          />
        </div>
        <div class="grid grid-cols-2 gap-1.5">
          <dojo-single-select
            label="Position"
            [formCtrl]="primLabelPositionCtrl"
            [options]="labelPositionOptions"
            optionLabel="label"
            optionValue="value"
            [size]="'s'"
            placeholder="Default"
            (selectionChange)="onPrimLabelDisplayChange('position', $event)"
          />
          <dojo-single-select
            label="Text Align"
            [formCtrl]="primLabelTextAlignCtrl"
            [options]="labelTextAlignOptions"
            optionLabel="label"
            optionValue="value"
            [size]="'s'"
            placeholder="Default"
            (selectionChange)="onPrimLabelDisplayChange('textAlign', $event)"
          />
        </div>
        <div class="grid grid-cols-2 gap-1.5">
          <dojo-number-input
            label="Font Size"
            [formCtrl]="primLabelFontSizeCtrl"
            [min]="6"
            [max]="36"
            [step]="1"
            [size]="'s'"
          />
        </div>
      }

      <!-- Primitive: Point -->
      @if (primitiveType() === 'point') {
        <div class="grid grid-cols-2 gap-1.5">
          <div class="flex min-w-0 items-end gap-0.5">
            @if (primExpressionModes().has('pointX')) {
              <dojo-text-input
                class="min-w-0 flex-1"
                label="X"
                [formCtrl]="getPrimExprCtrl('pointX')"
                [size]="'s'"
                placeholder="expression"
              />
              <button
                class="mb-0.5 shrink-0 cursor-pointer rounded px-1 py-0.5 text-[9px] font-bold text-sky-500 hover:bg-red-50 hover:text-red-500"
                title="Switch to number"
                (click)="onPrimSwitchToNumber('pointX')"
              >
                fx
              </button>
            } @else {
              <dojo-number-input
                class="min-w-0 flex-1"
                label="X"
                [formCtrl]="primPointXCtrl"
                [step]="0.5"
                [size]="'s'"
              />
              <button
                class="mb-0.5 shrink-0 cursor-pointer rounded px-1 py-0.5 text-[9px] font-bold text-neutral-300 hover:bg-sky-50 hover:text-sky-500"
                title="Switch to expression"
                (click)="onPrimSwitchToExpression('pointX')"
              >
                fx
              </button>
            }
          </div>
          <div class="flex min-w-0 items-end gap-0.5">
            @if (primExpressionModes().has('pointY')) {
              <dojo-text-input
                class="min-w-0 flex-1"
                label="Y"
                [formCtrl]="getPrimExprCtrl('pointY')"
                [size]="'s'"
                placeholder="expression"
              />
              <button
                class="mb-0.5 shrink-0 cursor-pointer rounded px-1 py-0.5 text-[9px] font-bold text-sky-500 hover:bg-red-50 hover:text-red-500"
                title="Switch to number"
                (click)="onPrimSwitchToNumber('pointY')"
              >
                fx
              </button>
            } @else {
              <dojo-number-input
                class="min-w-0 flex-1"
                label="Y"
                [formCtrl]="primPointYCtrl"
                [step]="0.5"
                [size]="'s'"
              />
              <button
                class="mb-0.5 shrink-0 cursor-pointer rounded px-1 py-0.5 text-[9px] font-bold text-neutral-300 hover:bg-sky-50 hover:text-sky-500"
                title="Switch to expression"
                (click)="onPrimSwitchToExpression('pointY')"
              >
                fx
              </button>
            }
          </div>
        </div>
        <dojo-text-input label="Name" [formCtrl]="primPointNameCtrl" [size]="'s'" />
      }

      <!-- Primitive: Line -->
      @if (primitiveType() === 'line') {
        <div class="grid grid-cols-2 gap-1.5">
          <div class="flex min-w-0 items-end gap-0.5">
            @if (primExpressionModes().has('fromX')) {
              <dojo-text-input
                class="min-w-0 flex-1"
                label="From X"
                [formCtrl]="getPrimExprCtrl('fromX')"
                [size]="'s'"
                placeholder="expression"
              />
              <button
                class="mb-0.5 shrink-0 cursor-pointer rounded px-1 py-0.5 text-[9px] font-bold text-sky-500 hover:bg-red-50 hover:text-red-500"
                title="Switch to number"
                (click)="onPrimSwitchToNumber('fromX')"
              >
                fx
              </button>
            } @else {
              <dojo-number-input
                class="min-w-0 flex-1"
                label="From X"
                [formCtrl]="primLineFromXCtrl"
                [step]="0.5"
                [size]="'s'"
              />
              <button
                class="mb-0.5 shrink-0 cursor-pointer rounded px-1 py-0.5 text-[9px] font-bold text-neutral-300 hover:bg-sky-50 hover:text-sky-500"
                title="Switch to expression"
                (click)="onPrimSwitchToExpression('fromX')"
              >
                fx
              </button>
            }
          </div>
          <div class="flex min-w-0 items-end gap-0.5">
            @if (primExpressionModes().has('fromY')) {
              <dojo-text-input
                class="min-w-0 flex-1"
                label="From Y"
                [formCtrl]="getPrimExprCtrl('fromY')"
                [size]="'s'"
                placeholder="expression"
              />
              <button
                class="mb-0.5 shrink-0 cursor-pointer rounded px-1 py-0.5 text-[9px] font-bold text-sky-500 hover:bg-red-50 hover:text-red-500"
                title="Switch to number"
                (click)="onPrimSwitchToNumber('fromY')"
              >
                fx
              </button>
            } @else {
              <dojo-number-input
                class="min-w-0 flex-1"
                label="From Y"
                [formCtrl]="primLineFromYCtrl"
                [step]="0.5"
                [size]="'s'"
              />
              <button
                class="mb-0.5 shrink-0 cursor-pointer rounded px-1 py-0.5 text-[9px] font-bold text-neutral-300 hover:bg-sky-50 hover:text-sky-500"
                title="Switch to expression"
                (click)="onPrimSwitchToExpression('fromY')"
              >
                fx
              </button>
            }
          </div>
          <div class="flex min-w-0 items-end gap-0.5">
            @if (primExpressionModes().has('toX')) {
              <dojo-text-input
                class="min-w-0 flex-1"
                label="To X"
                [formCtrl]="getPrimExprCtrl('toX')"
                [size]="'s'"
                placeholder="expression"
              />
              <button
                class="mb-0.5 shrink-0 cursor-pointer rounded px-1 py-0.5 text-[9px] font-bold text-sky-500 hover:bg-red-50 hover:text-red-500"
                title="Switch to number"
                (click)="onPrimSwitchToNumber('toX')"
              >
                fx
              </button>
            } @else {
              <dojo-number-input
                class="min-w-0 flex-1"
                label="To X"
                [formCtrl]="primLineToXCtrl"
                [step]="0.5"
                [size]="'s'"
              />
              <button
                class="mb-0.5 shrink-0 cursor-pointer rounded px-1 py-0.5 text-[9px] font-bold text-neutral-300 hover:bg-sky-50 hover:text-sky-500"
                title="Switch to expression"
                (click)="onPrimSwitchToExpression('toX')"
              >
                fx
              </button>
            }
          </div>
          <div class="flex min-w-0 items-end gap-0.5">
            @if (primExpressionModes().has('toY')) {
              <dojo-text-input
                class="min-w-0 flex-1"
                label="To Y"
                [formCtrl]="getPrimExprCtrl('toY')"
                [size]="'s'"
                placeholder="expression"
              />
              <button
                class="mb-0.5 shrink-0 cursor-pointer rounded px-1 py-0.5 text-[9px] font-bold text-sky-500 hover:bg-red-50 hover:text-red-500"
                title="Switch to number"
                (click)="onPrimSwitchToNumber('toY')"
              >
                fx
              </button>
            } @else {
              <dojo-number-input
                class="min-w-0 flex-1"
                label="To Y"
                [formCtrl]="primLineToYCtrl"
                [step]="0.5"
                [size]="'s'"
              />
              <button
                class="mb-0.5 shrink-0 cursor-pointer rounded px-1 py-0.5 text-[9px] font-bold text-neutral-300 hover:bg-sky-50 hover:text-sky-500"
                title="Switch to expression"
                (click)="onPrimSwitchToExpression('toY')"
              >
                fx
              </button>
            }
          </div>
        </div>
        <dojo-text-input label="Name" [formCtrl]="primLineNameCtrl" [size]="'s'" />
      }

      <!-- Primitive: Polygon — vertex count display only -->
      @if (primitiveType() === 'polygon') {
        <span class="text-xs text-neutral-400">Vertices: edit in JSON</span>
      }
    } @else {
      <!-- Function/Feature params -->
      @if (numberParamEntries().length > 0) {
        <div class="flex flex-col gap-1.5">
          <div class="grid grid-cols-2 gap-1.5">
            @for (entry of numberParamEntries(); track entry.key) {
              <div class="flex min-w-0 items-end gap-0.5">
                <dojo-number-input
                  class="min-w-0 flex-1"
                  [label]="entry.key"
                  [formCtrl]="entry.ctrl"
                  [min]="entry.min"
                  [max]="entry.max"
                  [step]="entry.step"
                  [size]="'s'"
                />
                @if (isFunction()) {
                  <button
                    class="mb-0.5 shrink-0 cursor-pointer rounded px-1 py-0.5 text-[9px] font-bold text-neutral-300 hover:bg-sky-50 hover:text-sky-500"
                    title="Switch to expression"
                    (click)="onSwitchToExpression(entry.key)"
                  >
                    fx
                  </button>
                }
              </div>
            }
          </div>
        </div>
      }

      @if (expressionParamEntries().length > 0) {
        <div class="flex flex-col gap-1.5">
          <div class="grid grid-cols-2 gap-1.5">
            @for (entry of expressionParamEntries(); track entry.key) {
              <div class="flex min-w-0 items-end gap-0.5">
                <dojo-text-input
                  class="min-w-0 flex-1"
                  [label]="entry.key"
                  [formCtrl]="entry.ctrl"
                  [size]="'s'"
                  placeholder="number or expression"
                />
                @if (isFunction()) {
                  <button
                    class="mb-0.5 shrink-0 cursor-pointer rounded px-1 py-0.5 text-[9px] font-bold text-sky-500 hover:bg-red-50 hover:text-red-500"
                    title="Switch to number"
                    (click)="onSwitchToNumber(entry.key)"
                  >
                    fx
                  </button>
                }
              </div>
            }
          </div>
        </div>
      }

      @for (key of booleanParamKeys(); track key) {
        <mat-slide-toggle
          class="mt-1"
          [checked]="getBooleanParamValue(key)"
          (change)="onParamFieldChange(key, $event.checked)"
        >
          {{ key }}
        </mat-slide-toggle>
      }

      @for (key of selectParamKeys(); track key) {
        <dojo-single-select
          class="mt-1"
          [label]="key"
          [formCtrl]="getSelectCtrl(key)"
          [options]="getSelectOptions(key)"
          optionLabel="label"
          optionValue="value"
          [size]="'s'"
          (selectionChange)="onParamFieldChange(key, $event)"
        />
      }
    }
  }

  <!-- Display overrides (schema-driven) -->
  @if (styleSections().length > 0) {
    <div
      class="mt-1 border-t border-neutral-100 pt-2 text-[10px] font-semibold uppercase tracking-wider text-neutral-400"
    >
      Display
    </div>
    <dojo-style-editor
      [sections]="styleSections()"
      [styleData]="$any(elementDisplay() ?? {})"
      (styleDataChange)="onStyleEditorChange($event)"
    />
  }

  <!-- Snapping (point elements only) -->
  @if (showSnapping()) {
    <mat-slide-toggle class="mt-2" [checked]="snapGridEnabled()" (change)="onSnapGridEnabledChange($event.checked)">
      Grid Snap
    </mat-slide-toggle>

    @if (snapGridEnabled()) {
      <div class="border-l-2 border-neutral-100 pl-3">
        <div class="grid grid-cols-2 gap-1.5">
          <dojo-number-input label="Size X" [formCtrl]="snapGridSizeXCtrl" [step]="0.5" [min]="0.1" [size]="'s'" />
          <dojo-number-input label="Size Y" [formCtrl]="snapGridSizeYCtrl" [step]="0.5" [min]="0.1" [size]="'s'" />
        </div>
      </div>
    }

    <dojo-text-input
      class="mt-1"
      label="Attractors"
      [formCtrl]="snapAttractorsCtrl"
      [size]="'s'"
      placeholder="f, g (element IDs)"
    />

    @if (hasAttractors()) {
      <div class="flex flex-col gap-1.5 border-l-2 border-neutral-100 pl-3">
        <div class="grid grid-cols-2 gap-1.5">
          <dojo-number-input label="Distance" [formCtrl]="snapDistanceCtrl" [step]="0.1" [min]="0" [size]="'s'" />
          <dojo-number-input
            label="Snatch Dist."
            [formCtrl]="snapSnatchDistanceCtrl"
            [step]="0.1"
            [min]="0"
            [size]="'s'"
          />
        </div>
        <dojo-single-select
          label="Unit"
          [formCtrl]="snapUnitCtrl"
          [options]="snapUnitOptions"
          optionLabel="label"
          optionValue="value"
          [size]="'s'"
          (selectionChange)="onSnapUnitChange($event)"
        />
      </div>
    }
  }

  <!-- Available Values -->
  @if (valueGroups().length > 0) {
    <div class="mt-3 flex flex-col gap-2 border-t border-neutral-100 pt-2">
      @for (group of valueGroups(); track group.label) {
        <div>
          <div class="flex items-baseline gap-1.5">
            <span class="text-[10px] font-semibold uppercase tracking-wider text-neutral-400">{{ group.label }}</span>
            @if (group.pattern) {
              <span class="font-mono text-[9px] text-neutral-300">{{ group.pattern }}</span>
            }
          </div>
          <div class="mt-1 flex flex-wrap gap-1">
            @for (item of group.paths; track item.copyPath) {
              <button
                class="cursor-pointer rounded border border-sky-200 bg-sky-50 px-1.5 py-0.5 font-mono text-[10px] text-sky-600 transition-colors hover:bg-sky-100"
                (click)="copyToClipboard(item.copyPath)"
                [title]="'Click to copy: {' + item.copyPath + '}'"
              >
                {{ item.display }}
              </button>
            }
          </div>
        </div>
      }
      <span class="block text-[9px] text-neutral-300">Click to copy · use as {{ '{' }}path{{ '}' }}</span>
    </div>
  }
</div>
